import { Navigate, Outlet, useLocation } from 'react-router';

import { ErrorScreen } from '../shell/ErrorScreen';
import { LoadingScreen } from '../shell/LoadingScreen';
import { useSession } from './SessionProvider';

/**
 * Guards every note/image/alert/history/settings route (CLAUDE.md rule 10). Renders the
 * shared Spanish loading/error shell while the session bootstraps, sends an unauthenticated
 * visitor to sign-in with the page they wanted attached, and otherwise renders the route.
 *
 * This is a UI convenience, not the authorization boundary: the server refuses every owner
 * route with its own `401`/`403` regardless of what this component decides
 * (`docs/implementation/06-mobile-web.md`, Phase 6 rule: "frontend state never bypasses
 * server authorization or readiness guards").
 */
export function ProtectedRoute() {
  const { status, bootstrapError, retryBootstrap } = useSession();
  const location = useLocation();

  if (status === 'loading') {
    return <LoadingScreen message="Verificando tu sesión…" />;
  }

  if (status === 'error') {
    return (
      <ErrorScreen
        message="No se pudo verificar tu sesión. Revisa tu conexión e intenta de nuevo."
        detail={bootstrapError?.message}
        onRetry={() => {
          void retryBootstrap();
        }}
      />
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/iniciar-sesion" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
